import { styled } from "@mui/material";
import { DateTimePicker as MuiDatePickerPro } from "@mui/x-date-pickers-pro";
import CalendarIcon from "components/Icons/CalendarIcon";
import type { DateTimePickerProps } from "@mui/x-date-pickers-pro";

const DateTimePicker = styled((props: DateTimePickerProps) => {
  const { slotProps, ...rest } = props;
  return (
    <MuiDatePickerPro
      format="DD/MM/YYYY HH:mm A"
      minutesStep={undefined}
      slotProps={{
        ...slotProps,
        textField: { ...slotProps?.textField, variant: "standard" },
        openPickerIcon: { ...slotProps?.openPickerIcon, component: () => <CalendarIcon /> },
        openPickerButton: {
          ...slotProps?.openPickerButton,
          sx: { mb: "5px" },
          color: "primary",
        },
      }}
      {...rest}
    />
  );
})(({ theme }) => ({
  "& .MuiInputLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled": {
      opacity: 0.5,
    },
  },
  ".MuiInputBase-root:hover::before": {
    borderColor: theme.palette.secondary1[100],
  },
  ".MuiInput-root::after": {
    borderColor: theme.palette.secondary1[100],
  },
})) as typeof MuiDatePickerPro;

export default DateTimePicker;
